import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ForwardOutlinedSvg from "@ant-design/icons-svg/es/asn/ForwardOutlined";
import AntdIcon from '../components/AntdIcon';
var ForwardOutlined = function ForwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: ForwardOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(ForwardOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ForwardOutlined';
}
export default RefIcon;